import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "../../components/common/Button";
import { Input } from "../../components/common/Input";
import { api } from "../../services/api";

export default function ProfileSetupPage() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(user?.firstName ?? "");
  const [lastName, setLastName] = useState(user?.lastName ?? "");
  const [handicap, setHandicap] = useState(user?.handicap?.toString() ?? "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.users.updateProfile({
        firstName,
        lastName,
        displayName: `${firstName} ${lastName}`,
        handicap: handicap ? Number(handicap) : undefined,
      });
      await refreshUser();
      navigate("/");
    } catch (err: any) {
      setError(err.message ?? "Failed to save profile");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen bg-primary-800 flex flex-col items-center justify-center px-6 py-12'>
      <div className='w-full max-w-sm bg-white rounded-3xl shadow-xl p-6'>
        <h2 className='text-2xl font-bold text-primary-800 mb-1'>
          Complete Your Profile
        </h2>
        <p className='text-sm text-gray-500 mb-6'>
          Just a few details to get you started.
        </p>

        <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
          <Input
            label='First Name'
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
            autoComplete='given-name'
          />
          <Input
            label='Last Name'
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
            autoComplete='family-name'
          />
          <Input
            label='Handicap Index (optional)'
            type='number'
            min='0'
            max='54'
            step='0.1'
            value={handicap}
            onChange={(e) => setHandicap(e.target.value)}
            placeholder='e.g. 10.4'
          />

          {error && <p className='text-sm text-red-500'>{error}</p>}

          <Button type='submit' fullWidth loading={loading}>
            Save and Continue
          </Button>
        </form>
      </div>
    </div>
  );
}
